<template>
  <section>
    <div
      class="pkg-unpack-wrapper"
      :style="'zIndex: ' + zIndex"
    >
      <div class="pkg-unpack-mask" />
      <div
        ref="pkgFileUnpack"
        class="pkg-unpack-content"
        :style="{ left: left + 'px', top: top + 'px' }"
      >
        <div class="pkg-unpack-title">
          <span>{{ $t('请选择解压位置') }}</span>
          <span
            class="icon i-close"
            @click="close"
          />
        </div>
        <div class="file-unpack">
          <div class="unpack-content">
            <el-radio-group v-model="notation">
              <p class="pkg-radio">
                <el-radio
                  label="download"
                >
                  <span />
                </el-radio><span
                  class="label-custom"
                >{{ $t('解压并下载到本地')}}</span>
              </p>
              <p class="pkg-radio">
                <el-radio label="unpack" :disabled="true">
                  <span />
                </el-radio><span class="label-custom">{{ $t('解压到网盘') }}</span>
              </p>
              <div class="pkg-unpack">
                <p class="pkg-radio">
                  <el-radio
                    :disabled="notation !== 'unpack'"
                    label="unpack"
                  >
                    <span />
                  </el-radio><span
                    class="label-custom-unpack"
                    :class="{ selected: notation === 'unpack' }"
                  >{{ $t('解压到压缩包所在目录') }}{{ pathName }}</span>
                </p>
                <p
                  class="pkg-other"
                  :class="{ selected: notation === 'unpack' }"
                  @click="chooseDir"
                >
                  <span>{{ $t('选择其他目录') }}</span>
                </p>
              </div>
            </el-radio-group>
          </div>
          <div class="unpack-footer">
            <button class="lv-bn lv-80 c-btn lv-rm-12" @click="close">{{ $t('取消') }}</button>
            <button class="lv-bn lv-80 s-btn" @click="startPkg">{{ $t('确定') }}</button>
          </div>
        </div>
      </div>
    </div>
    <pkg-password
      v-if="showPasswordDialog"
      ref="pkgPassword"
      :show-password-dialog.sync="showPasswordDialog"
      :check-pwd-info="checkPwdInfo"
      @update:checkPwdInfo="updateCheckPwdInfo"
      @confirmPkg="confirmPkg"
      @clearPassword="clearPassword"
    />
    <co-confirm
      v-model="downloadClient"
      :title="this.$t('提示')"
      :content="this.$t('网页目前仅支持单文件解压缩到本地')"
      :describe="this.$t('您可以在客户端进行该操作')"
      :isDescribe="true"
      :sureBtn="this.$t('下载客户端')"
    />
  </section>
</template>

<script>
import store from 'store'
import { getWidthOrHeight, isClient } from 'js/util/util'
import coConfirm from 'components/common/confirm/index.vue'
import PkgPassword from '../pkg-password/pkg-password.vue'

export default {
  components: {
    PkgPassword,
    coConfirm,
  },
  props: ['isUnpack', 'path', 'parentData', 'pkgData', 'allPkgData', 'checkPwdInfo', 'password'],
  data() {
    return {
      zIndex: store.state.maskZIndex,
      left: 0,
      top: 0,
      notation: 'download', // 标识解压或下载，默认解压
      showPasswordDialog: false,
      timer: null,
      resizeTimer: null,
      // totalConfirm,
      confirmData: {
        datalist: {
          virusConfirm: {
            title: this.$t('提示'),
            content: this.$t('当前文件携带病毒，是否继续操作？'),
            cb() {
              this.$emit('confirmPass')
            },
          },
        },
        props: {
          title: '',
          content: '',
          cb() {},
        },
        showConfirm: false,
      },
      downloadClient: true,
    }
  },
  computed: {
    pathType() {
      const { $route } = this
      return $route.meta.path_type || $route.name
    },
    selectedLen() {
      return store.getters.pkgSelectedLength
    },
    isVirus() {
      // 是否病毒
      return this.parentData.has_virus
    },
    isEncrypted() {
      // 是否加密
      return this.parentData.is_encrypted
    },
    selectedData() {
      const data = store.state.pkgSelectedData.data.map((d) => d.data)
      if (this.selectedLen === 0) return {}
      return data
    },
    pathName() {
      const path = this.path.split('/').pop()
      if (path === '') {
        return ''
      }
      return `：${path}`
    },
    downloadLabel() {
      return this.selectedLen === 1 && !this.selectedData[0].isDir
        ? this.$t('解压并下载到本地')
        : this.$t('解压并下载到本地(目前只支持单文件下载到本地)')
    },
    correctPassword() {
      return sessionStorage.getItem('correctPassword')
    },
  },
  mounted() {
    this.setPos()
    window.addEventListener('resize', this.resize.bind(this, this), false)
    this.zIndex = store.state.maskZIndex
    store.commit('ADD_MASK_ZINDEX')
  },
  methods: {
    async startPkg() {
      if (this.notation === 'download') {
        this.confirmDownload()
      }
    },
    clearPassword() {
      this.$emit('clearPassword')
    },
    updateCheckPwdInfo(val) {
      this.$emit('update:checkPwdInfo', val)
    },
    confirmDownload() {
      if (!isClient()
     && (store.getters.pkgSelectedLength > 1 || (this.selectedData[0] && this.selectedData[0].isDir)
      || store.getters.pkgSelectedLength === 0)) {
        // 引导客户端操作
        this.$emit('downloadClient')
      } else if (this.isEncrypted && !this.password) {
        this.showPasswordDialog = true
      } else {
        this.download()
      }
    },
    download(data) {
      let pathArr
      let dlUrl
      let entryId
      const password = this.password || (data && data.password)
      if (store.getters.pkgSelectedLength > 0) {
        pathArr = this.selectedData.map((d) => d.path)
        dlUrl = this.selectedData[0].dl_url
        entryId = this.selectedData.map((d) => d.entry_id).join(',')
      } else {
        pathArr = this.allPkgData.map((d) => d.path)
        dlUrl = this.allPkgData[0].dl_url
      }
      this.$emit('download', {
        dlUrl, pathArr, password, entryId,
      })
    },
    extract() {
      let pathArr
      let extractUrl
      const { password } = this
      const pathType = this.pkgData.path_type
      const prefixNeid = this.pkgData.prefixNeid ? this.pkgData.prefixNeid : ''
      if (store.getters.pkgSelectedLength > 0) {
        pathArr = this.selectedData.map((d) => d.path)
        extractUrl = this.selectedData[0].extract_url
      } else {
        pathArr = '/'
        extractUrl = this.allPkgData[0].extract_url
      }
      this.$emit('extract', {
        extractUrl, pathArr, password, pathType, prefixNeid,
      })
    },
    confirmPass() {
      if (this.isEncrypted) {
        this.showPasswordDialog = true
      } else {
        this.confirmPkg()
      }
    },
    confirmPkg(val) {
      if (this.notation === 'download') {
        this.download({ password: `${this.$jsEncrypt.encrypt(val)}` }) // 单文件
      }
      if (this.notation === 'unpack') {
        this.extract() // 解压到当前目录
      }
    },
    confirmHandler(name) {
      this.confirmData.props = { ...this.confirmData.datalist[name] }
      this.confirmData.showConfirm = true
    },
    close() {
      this.$emit('update:isUnpack', false)
    },
    chooseDir() {
      if (this.notation !== 'unpack') return
      this.$emit('chooseDir')
    },
    setPos() {
      const $dialog = this.$refs.pkgFileUnpack
      const elemH = getWidthOrHeight($dialog, 'height')
      const elemW = getWidthOrHeight($dialog, 'width')
      const winH = window.innerHeight || document.documentElement.clientHeight
      const winW = window.innerWidth || document.documentElement.clientWidth
      this.left = (winW - elemW) / 2
      this.top = (winH - elemH) / 2
    },
    resize(vm) {
      clearTimeout(vm.resizeTimer)
      this.resizeTimer = setTimeout(vm.setPos, 100)
    },
  },
}
</script>

<style lang="less" scoped>
.pkg-unpack-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  .pkg-unpack-mask {
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .pkg-unpack-content {
    position: fixed;
    box-sizing: border-box;
    width: 450px;
    padding: 24px;
    font-size: 14px;
    background: #fff;
    border-radius: 4px;
    -webkit-box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
    .pkg-unpack-title {
      height: 24px;
      margin-bottom: 24px;
      line-height: 24px;
      span {
        display: inline-block;
        height: 24px;
        font-size: 18px;
        line-height: 24px;
        color: #1b2733;
      }
      .i-close {
        float: right;
        margin-top: 7px;
        margin-right: -7px;
        background-image: url(~image/close.svg);
        background-repeat: no-repeat;
      }
    }
    .file-unpack {
      .unpack-content {
        .el-radio {
          vertical-align: top;
        }
        .pkg-radio {
          margin-bottom: 12px;
          .label-custom {
            display: inline-block;
            margin-left: -30px;
            color: #1b2733;
            &.disabled {
              color: #929ca9;
            }
          }
          .label-custom-unpack {
            display: inline-block;
            max-width: 340px;
            margin-left: -30px;
            line-height: 1.5;
            color: #929ca9;
            &.selected {
              color: #1b2733;
            }
          }
        }
        .pkg-unpack {
          margin-left: 23px;
          .pkg-other {
            margin-left: 23px;
            color: #929ca9;
            cursor: not-allowed;
            &.selected {
              color: #0a64fa;
              cursor: pointer;
            }
          }
        }
      }
      .unpack-footer {
        float: right;
        /* display: flex;
        flex-direction: row-reverse;
        margin-top: 24px;
        .default-btn {
          margin-right: 10px;
        } */
      }
    }
  }
}
</style>
